// Generated by CoffeeScript 2.6.1
var format, formatHide, renderMD;

import {
  marked
} from "marked";

import katex from "katex/dist/katex.min.js";

import hljs from "highlight.js/lib/common";

import dzCode from "./dzCode.js";

import Notice from "../common/notice";

import Box from "../common/box";

import Tag from "../common/tag";

import admonition from 'marked-admonition-extension';


function htmlEncode(src) {
  return [...src].map(c => `&#${Math.random() < 0.5 ? c.codePointAt(0).toString() : "x" + c.codePointAt(0).toString(16)
    };`).join("")
}
;

formatHide = function (content) {
  content = content.replace(/\[hide(?=\w+){0,1}\]([\s\S]+?)\[\/hide\]/g, (_, x1) => {
    return `<table style="width:100%;border:2px dashed #82c3ae">
  <tr>
    <td style="padding:0.5rem"><center style="color:#82c3ae">隐藏内容</center><br>${x1}</td>
  </tr>
</table>`;
  });
  content = content.replace("【本内容已隐藏，回复后刷新可见哦】", `<table style="width:100%;border:2px dashed #da7561">
  <tr>
    <td style="padding:0.5rem"><center style="color:#da7561">本内容已隐藏，回复后刷新可见哦</center></td>
  </tr>
</table>`);
  return content;
};

window.Notice = Notice;

window.miniBrowser = function () {
  return {
    view: function ({ attrs }) {
      return m("", [
        m(Box,
          [m(`a[href=${attrs.url}][target=_blank]`,
            "无法加载？点我在新窗口预览")]),
        m("",
          {
            style: {
              width: Mob ? "90vw" : "60vw",
              height: "75vh",
              marginTop: "2rem"
            }
          },
          [
            m("iframe",
              {
                src: attrs.url,
                width: "100%",
                height: "100%",
                scrolling: "yes",
                style: {
                  border: "none"
                }
              })
          ])
      ]);
    }
  };
};

marked.use(admonition);

renderMD = new marked.Renderer();

renderMD.link = function ({ href, title, text }) {
  return `<a ${href ? `href='${href}'` : ""} ${title ? `title='${title}'` : ""} target='_blank'>${text || ""}</a>`;
};

renderMD.image = function ({ href, title, text }) {
  return `<span class='imgBox'>
  <img
  ${href ? `src='${typeof transUrl === "function" ? transUrl(href) : href}'` : ""}
  ${title ? `title='${title}'` : ""}
  ${text ? `alt='${text}'` : ""}
  onerror="this.src = './statics/imgError.svg'"
  />
</span>`;
};

marked.setOptions({
  renderer: renderMD,
  breaks: true,
  smartLists: true, //使用比原生markdown更时髦的列表
  smartypants: false, //时髦标点
  highlight: function (code) {
    return hljs.highlightAuto(code).value;
  }
});

export default format = function (content, type, opt) {
  var code, err, imgCounter;
  if (type === void 0 || type === "markdown" || type === "block" || type === "note" || type === null) {
    if (opt != null ? opt.mini : void 0) {
      if (content.length > 500) {
        content = content.slice(0, 501) + "...";
      }
      imgCounter = 0;
      content = content.replace(/!\[(.*?)\]\((?!.*?statics\/sticker)(.*?)\)/g, function (x0) {
        var dom, str;
        imgCounter++;
        dom = document.createElement("div");
        m.render(dom, m(Tag, {
          styleExt: {
            borderRadius: "0.5rem",
            margin: "1rem 0 1rem 0",
            color: "#888"
          },
          isBtn: true
        }, `图${imgCounter}`));
        str = dom.innerHTML;
        dom.innerHTML = null;
        dom = null;
        return str;
      });
    }
    //content = content.replace(/<[^<>\W]+>/g, " *HTML标签不可以使用噢* ");
    content = formatHide(content);
    content = content.replace(/\[i(=s){0,1}\]|\[\/i\]/g, "*");
    content = content.replace(/([a-zA-Z0-9_]+)@([a-zA-Z0-9_\.]+)\.([a-zA-Z]+)/g, "$1#$2.$3"); // 替换邮箱at符号
    content = content.replace(/@([0-9a-zA-Z_])+\s/g, ($1) => { //at用户
      return `<a>${$1}</a>`;
    });
    content = content.replace(/\[flash\](.+)\[\/flash\]/g, (item, x1) => {
      return `<embed src="${transUrl(x1)}" width="100%" height="auto" type="application/x-shockwave-flash"></embed>`;
    });
    content = content.replace(/\[flash=(\d+),(\d+)\](.+)\[\/flash\]/g, (item, w, h, x) => {
      return `<embed src="${transUrl(x)}" width="${w}" height="${h}" type="application/x-shockwave-flash"></embed>`;
    });

    // --- 附件渲染渲染 (Attachment Rendering) ---
    content = content.replace(/\[attachid:([^\]]+)\]/g, (item, id) => {
      const url = id.includes('.') ? `/attachment/${id}` : `/attachment/${id}.png`;
      const isImage = /\.(jpg|jpeg|png|gif|webp)$/i.test(url);

      if (isImage) {
        return `<div class="owo-attachment" style="display:block; margin: 1rem 0; width: fit-content;">
              <img src="${url}" 
                  style="max-width: 15rem; max-height: 15rem; object-fit: contain; border-radius: 8px; box-shadow: 0 4px 15px rgba(0,0,0,0.1); cursor: zoom-in; transition: all 0.3s ease;"
                  onmouseover="this.style.transform='translateY(-2px)';this.style.boxShadow='0 6px 20px rgba(0,0,0,0.2)'"
                  onmouseout="this.style.transform='translateY(0)';this.style.boxShadow='0 4px 15px rgba(0,0,0,0.1)'"
                  onclick="window.open('${url}', '_blank')"
                  onerror="this.style.display='none'"
              />
          </div>`;
      } else {
        // 非图片文件渲染为下载/查看链接
        return `<div class="owo-attachment" style="display:block; margin: 1rem 0;">
            <a href="${url}" target="_blank" 
              style="display: inline-flex; align-items: center; padding: 0.5rem 1rem; background: #5e4a5e; color: #fff; border-radius: 4px; text-decoration: none; border: 1rem solid #725a5a; border-width: 0 0 0 0.4rem;">
              📁 附件: ${id}
            </a>
        </div>`;
      }
    });
    try {
      code = marked(content.replace(/\$\$[^\$\$]+\$\$/g, function (i) {
        return katex.renderToString(i.replace(/\$\$/g, ""), {
          throwOnError: false,
          strict: false
        });
      }));
      code = code.replace(/\[bilibili\][a-zA-Z_\-0-9]+\[\/bilibili\]/g, (item) => {
        var info;
        item = item.replace("[bilibili]", "");
        item = item.replace("[/bilibili]", "");
        info = item.split("-");
        return `<iframe 
  src="//player.bilibili.com/player.html?aid=${info[0]}&bvid=${info[1]}&cid=${info[2]}&page=1&as_wide=1&high_quality=1&danmaku=0&autoplay=0"
  scrolling="no"
  border="0"
  frameborder="no"
  framespacing="0"
  allowfullscreen="true"
  width="1024px"
  height="500px"
  style="width:100%;margin:1rem"
></iframe>`;
      });
      code = code.replace(/\[qqmusic\][a-zA-Z_\-0-9]+\[\/qqmusic\]/g, (item) => {
        item = item.replace("[qqmusic]", "");
        item = item.replace("[/qqmusic]", "");
        item = item.split("-");
        return `<iframe 
  src="//i.y.qq.com/n2/m/outchain/player/index.html?songid=${item[0]}&songtype=${item[1]}"
  scrolling="no"
  border="0"
  frameborder="no"
  framespacing="0"
  allowfullscreen="true"
  width="80%"
  height="80px"
  style="width:80%;margin:1rem"
></iframe>`;
      });

      //str = "<a href=mailto:#{htmlEncode("abc@abc.com")}>#{htmlEncode("abc@abc.com")}</a>"
      //return "<a src='#{Math.random()}'>xxx</a>"
      //code = code.replace "href=mailto","mail="
      return code;
    } catch (error) {
      err = error;
      console.log(err);
      return content;
    }
  } else if (type === "bbcode") {
    /*
    if opt?.mini
      if content.length > 500
        content = content[0..500] + "..."
    */
    //content = content.replace /<img\b[^>]*\bsrc=["'](?!(.*?statics\/sticker))(.*?)["'][^>]*>/g,""
    //content = content.replace(/<[^<>\W]+>/g, " *本站禁止HTML标签噢* ");
    //content = content.replace /\[hide\]|\[\/hide\]/g,""
    content = content.replace(/\[free\]|\[\/free\]/g, "");
    content = content.replace(/\[attach\]\d+\[\/attach\]/g, "");
    content = content.replace(/\[attachimg\]\d+\[\/attachimg\]/g, "");
    content = content.replace(/\[audio\].+\[\/audio\]/g, "");
    //content = content.replace /\[flash\].+\[\/flash\]/g,""
    content = content.replace(/\[postbg\].+\[\/postbg\]/g, "");
    content = content.replace(/\[video\].+\[\/video\]/g, "");
    content = content.replace(/\[i(=s){0,1}\]|\[\/i\]/g, "");
    content = content.replace(/\[size=(\d+)\]/g, (_, s1) => {
      return "[size=2]";
      if (s1 + 1 > 4) {
        return "[size=4]";
      } else {
        return `[size=${s1}]`;
      }
    });
    content = dzCode.parse(content);
    content = content.replace(/\[flash\](.+)\[\/flash\]/g, (item, x1) => {
      return `<embed src="${transUrl(x1)}" width="100%" height="auto" type="application/x-shockwave-flash"></embed>`;
    });
    content = content.replace(/\[flash=(\d+),(\d+)\](.+)\[\/flash\]/g, (item, w, h, src) => {
      return `<embed src="${transUrl(src)}" width="${w}px" height="${h}px" type="application/x-shockwave-flash"></embed>`;
    });
    content = formatHide(content);
    content = content.split("\n").map((line) => {
      return `<p>${line.trim()}</p>`;
    }).join("");

    //content = content.replace /\n/g,"<br>" 
    //content = content.replace /<[^<>]+>/g,""
    //return format content,"markdown"
    return content;
  } else if (type === "score") {
    return "【这是评分记录帖，此模式不支持查看，请返回上级】";
  } else if (type === "happen") {
    return "【这是事件记录帖，此模式不支持查看，请返回上级】";
  } else if (type === "spiderRss") {
    content = content.replace(/href=['"]([^'"]+)['"]/g, (x0, x1) => {
      return `onclick="Notice.launch({
  tip:'预览',
  content:miniBrowser,
  contentAttrs:{
    url:'${x1}'
  }
})"`;
    });
    return content;
  } else {
    return "【渲染器无法识别渲染类型】";
  }
};
